<template>
    <div class="az-lotes-itens">
        <v-flex xs12 sm4 d-flex>
            <v-select label="Tipo de Importação" placeholder="Selecione"
                      v-if="isEditavel && editando && licitacao.origem === 'INTERNA'"
                      v-model="tipoImportacao"
                      :items="tiposImportacao"
                      v-validate="'required'"
                      style="padding-right: 10px"
            ></v-select>
        </v-flex>
        <edl-file-upload :accept="'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,' +
                        ' application/vnd.ms-excel'" :repository="repository" ref="azFileUploadLotesItens"
                        v-if="isEditavel && editando && tipoImportacao === 'Planilha' && licitacao.origem === 'INTERNA'">
            <a @click.prevent="$refs.azFileUploadLotesItens.openFileSelector()">
                <v-icon>archive</v-icon>
                Importar Planilha
            </a>
            <p>
                <a href="importacao/Lotes.xlsx" class="link-download-modelo" download>Baixe o modelo aqui</a> e importe
                no botão
                acima.
            </p>
        </edl-file-upload>

        <edl-file-upload :accept="'text/plain'" :repository="repository" ref="azFileUploadLotesItens"
                        v-if="isEditavel && editando && tipoImportacao !== 'Planilha' && licitacao.origem === 'INTERNA'">
            <a @click.prevent="$refs.azFileUploadLotesItens.openFileSelector()">
                <v-icon>archive</v-icon>
                Importar TXT
            </a>
            <p>
                <a :href="'importacao/' + tipoImportacao + '.txt'" class="link-download-modelo" download>Baixe o modelo
                    do txt aqui</a> e importe no
                botão
                acima.
            </p>
        </edl-file-upload>

        <a v-if="possuiLotes && editando && isEditavel && licitacao.origem === 'INTERNA'" class="reimport-button"
           @click="mostrarDialogRemoverLotes = true">
            <v-icon>archive</v-icon>
            Reimportar Lotes/Itens
        </a>

        <v-flex xs12 sm6 d-flex v-if="licitacao.status === 'ENCERRADO' && licitacao.origem === 'INTERNA'">
            <v-flex xs8 sm8>
                <v-select label="Modelo de Exportação" placeholder="Selecione"
                          v-model="modeloExportacao"
                          :items="modelosExportacao"
                          style="padding-right: 10px"
                          name="Modelo de Exportação"
                          v-validate="'required'"
                          :error-messages="errors.collect('Modelo de Exportação')"
                ></v-select>
            </v-flex>
            <v-flex xs4 sm4>
                <a class="reimport-button"
                   @click="exportar()" style="position: relative; top: 20px">
                    <v-icon>import_export</v-icon>
                    Exportar Resultado
                </a>
            </v-flex>
        </v-flex>

        <v-flex xs12 sm12 style="display: flex" class="justify-start">
          <span v-if="licitacao.origem === 'EXTERNA' && (licitacao.status === 'ABERTO' || licitacao.status === 'SUSPENSO' || licitacao.status === 'ENCERRADO') && !ehUsuarioFornecedor"
                class="pr-1">
            <a class="reimport-button"
               @click="exportarSgc()">
              <v-icon>import_export</v-icon>
              Exportar Resultado
            </a>
          </span>
          <span v-if="licitacao.origemExecucao === 'SGC' && licitacao.origem === 'EXTERNA' && licitacao.status === 'AGUARDANDO_ABERTURA' && !ehUsuarioFornecedor"
                class="pr-1">
            <a class="reimport-button" style="margin-left: 15px;"
               @click="atualizarDadosSgc()">
              <v-icon>sync</v-icon>
              Atualizar Dados
            </a>
          </span>
          <span v-if="licitacao.status === 'ENCERRADO' && orgaoLogado && orgaoLogado.integracaoIPMAtiva"
                class="pl-1">
            <a class="reimport-button"
               @click="exportarIpm()">
              <v-icon>import_export</v-icon>
              Exportar para a IPM
            </a>
          </span>
        </v-flex>
        <br>

        <div v-if="possuiLotes" class="container-tabela-itens">
            <v-flex xs12 sm12 d-flex>
                <v-form @submit.prevent="atualizarLotesItens">
                    <v-data-table
                            :headers="headersTabelaLotes"
                            :items="lotesLicitacao"
                            :loading="false"
                            :disable-initial-sort="true"
                            hide-actions
                            class="az-table-list tabela-lotes-itens"
                            ref="datatableitens"
                    >
                        <template slot="items" slot-scope="props">
                            <td class="az-nowrap-cell py-3">
                                <div class="tipo-item">
                                    <span>{{ props.item.licitacaoLote.lote.resumoDescricao }}</span>
                                    <span v-if="possuiItemComPeriodicidade && !isFornecedor && itemEhPeriodico(props.item)"
                                          class="chip-periodico">
                                        <v-icon class="chip-periodico__icone">event</v-icon>
                                        Periódico
                                    </span>
                                </div>
                            </td>

                            <td class="az-nowrap-cell">
                                <span class="az-nowrap-cell__content">
                                    {{ props.item.itemCompra.codigo }}
                                    <v-layout row v-if="ehModalidadeLeilao" class="az-inline-layout">
                                        <v-icon
                                            icon
                                            small
                                            class="mr-1 az-cursor-pointer"
                                            @click.stop="executarAcaoImagem(props.item, 0)"
                                            :title="podeEditar() && naoContemImagem(props.item) ? 'Adicionar Imagens' : 'Visualizar Imagens'"
                                        >
                                            {{ podeEditar() && naoContemImagem(props.item) ? 'add_a_photo' : 'mdi-camera' }}
                                        </v-icon>

                                        <span class="az-cursor-pointer" @click.stop="executarAcaoImagem(props.item, 0)">
                                          {{ podeEditar() && naoContemImagem(props.item) ? 'Adicionar' : props.item.imagens ? props.item.imagens.length : 0 }}
                                        </span>

                                        <edl-file-upload
                                              ref="uploadImagemItem"
                                              :accept="extensoesPermitidas.join(',')"
                                              :repository="repository"
                                              :multiple="true"
                                              style="display: none"
                                              @uploadCompleto="onUploadImagemItemCompleto"
                                        />
                                    </v-layout>
                                  </span>
                            </td>

                            <td v-if="ehPerfilSiga">{{ props.item.numSequencia }}</td>
                            <td v-if="!editando || !isEditavel">
                                {{ tiposNegociacao[props.item.licitacaoLote.tipoNegociacao] }}
                            </td>
                            <td v-else class="select-itens-tabela">
                                <az-combo-enum-licitacao :name="'Negociacao' + props.item.id" placeholder="Selecione"
                                               v-model="props.item.licitacaoLote.tipoNegociacao" is-required
                                               :enum-object="tiposNegociacao"
                                               :disabled="possuiProposta"
                                               @input="mudarTipoNegociacaoItensMesmoLote(props.item.licitacaoLote.lote.id, props.item.licitacaoLote.tipoNegociacao)"
                                ></az-combo-enum-licitacao>
                            </td>
                            <td>
                                <v-tooltip top max-width="750">
                                    <span slot="activator">{{ props.item.itemCompra.descricaoCompleta | az-clip-text(50) }}</span>
                                    <span>{{ props.item.itemCompra.descricaoCompleta }}</span>
                                </v-tooltip>
                            </td>
                            <td v-if="!editando || !isEditavel && !isMelhorTecnica">{{ props.item.licitacaoLote.incluirFicha ? 'Sim' : 'Não'}}
                            </td>
                            <td v-else-if="!isMelhorTecnica" class="select-itens-tabela">
                                <v-select :name="'IncluirFicha' + props.item.id"
                                          v-model="props.item.licitacaoLote.incluirFicha"
                                          v-validate="'required'"
                                          :error-messages="errors.collect('IncluirFicha' + props.item.id)"
                                          :disabled="possuiProposta"
                                          :items="tiposIncluirFichaCatalogo"
                                          @input="mudarFichaCatalogoItensMesmoLote(props.item.licitacaoLote.lote.id, props.item.licitacaoLote.incluirFicha, 'incluirFicha')"
                                ></v-select>
                            </td>
                            <td v-if="!editando || !isEditavel && !isMelhorTecnica">{{ props.item.licitacaoLote.incluirCatalogo ? 'Sim' : 'Não' }}</td>
                            <td v-else-if="!isMelhorTecnica" class="select-itens-tabela">
                                <v-select :name="'IncluirCatalogo' + props.item.id"
                                          v-model="props.item.licitacaoLote.incluirCatalogo"
                                          v-validate="'required'"
                                          :error-messages="errors.collect('IncluirCatalogo' + props.item.id)"
                                          :disabled="possuiProposta"
                                          :items="tiposIncluirFichaCatalogo"
                                          @input="mudarFichaCatalogoItensMesmoLote(props.item.licitacaoLote.lote.id, props.item.licitacaoLote.incluirCatalogo, 'incluirCatalogo')"
                                ></v-select>
                            </td>
                            <td>{{ props.item.itemCompra.unidade.descricao }}</td>
                            <td style="text-align: right;">
                                <formatador-moeda :valor="props.item.quantidade" :casas-decimais="casasDecimaisQuantidade"></formatador-moeda>
                            </td>
                            <td style="text-align: right;" v-if="!isFornecedor">
                                <formatador-moeda :valor="props.item.valorUnitario" :casas-decimais="licitacao.casasDecimais"></formatador-moeda>
                            </td>
                          <td style="text-align: right;" v-if="!isFornecedor && (isMenorPreco || isMaiorDesconto)">
                                <formatador-moeda :valor="props.item.valorTotal" :casas-decimais="2"></formatador-moeda>
                            </td>
                          <td style="text-align: right;" v-if="!isFornecedor && isMaiorDesconto">
                            <formatador-moeda :valor="props.item.valorDesconto" :casas-decimais="licitacao.casasDecimais"></formatador-moeda>
                            %
                          </td>
                          <td style="text-align: center;" v-if="possuiItemComPeriodicidade && !isFornecedor">
                            <v-tooltip top max-width="320" content-class="tooltip-periodicidade-container" v-if="itemEhPeriodico(props.item)">
                                <v-icon slot="activator" small color="primary">info_outline</v-icon>
                                <div class="tooltip-periodicidade">
                                    <div class="tooltip-periodicidade__titulo">Periodicidade (informativo)</div>
                                    <div class="tooltip-periodicidade__linha">
                                        <span>Período:</span>
                                        <span>{{ dadosTooltipPeriodicidade(props.item).meses }} meses</span>
                                    </div>
                                    <div class="tooltip-periodicidade__linha">
                                        <span>Valor total do período:</span>
                                        <span>R$ {{ dadosTooltipPeriodicidade(props.item).valorTotal }}</span>
                                    </div>
                                    <div class="tooltip-periodicidade__linha">
                                        <span>Valor médio mensal:</span>
                                        <span>R$ {{ dadosTooltipPeriodicidade(props.item).valorMedioMensal }}</span>
                                    </div>
                                    <div class="tooltip-periodicidade__divisor"></div>
                                    <div class="tooltip-periodicidade__aviso">
                                        Informação apenas para consulta.<br>
                                        Não altera os valores da licitação.
                                    </div>
                                </div>
                            </v-tooltip>
                          </td>
                        </template>
                    </v-data-table>
                </v-form>
            </v-flex>
            <div class="resume-itens" v-if="possuiLotes && !isFornecedor && (isMenorPreco || isMaiorOferta || isTecnicaPreco || isMaiorDesconto)">
                <div class="resume">
                    <label>Total Unitário: </label>
                    <span>R$ <formatador-moeda :valor="totalUnitario" :casas-decimais="licitacao.casasDecimais"></formatador-moeda></span>
                    <span class="separator">|</span>
                    <label>Total Geral: </label>
                    <span>R$ <formatador-moeda :valor="totalGeral" :casas-decimais="2"></formatador-moeda></span>
                  <template v-if="isMaiorDesconto">
                    <span class="separator">|</span>
                    <label>Média Desconto: </label>
                    <span>
                      <formatador-moeda :valor="mediaDesconto" :casas-decimais="licitacao.casasDecimais"></formatador-moeda>%
                    </span>
                  </template>
                </div>
            </div>
        </div>
        <div class="az-actions-form">
            <div class="align-left"></div>
            <div class="align-right" v-if="possuiLotes && editando && isEditavel">
                <a class="action-primary" @click="atualizarLotesItens">Salvar</a>
            </div>
        </div>
        <az-ops title="Ops! Nenhum tipo encontrado."
                message="Adicione tipos através do botão importar com a tela no modo de edição."
                v-if="!possuiLotes && !editando"
        ></az-ops>
        <az-confirm @onConfirm="chamarEventoRemoverLotes(); mostrarDialogRemoverLotes = false;"
                    @onDecline="mostrarDialogRemoverLotes = false"
                    v-if="mostrarDialogRemoverLotes">
            Todos os tipos serão removidos! Tem certeza que deseja reimportar os tipos?
        </az-confirm>

        <imagem-carousel-dialog
            ref="imagemCarouselDialog"
            :fetch-action="actionTypes.BUSCAR_IMAGENS_ITEM_BASE64"
            :use-cache="true"
            @adicionarImagem="abrirUploadImagemItemPorId"
            @excluirImagem="excluirImagemItem"
        />
    </div>
</template>

<script>
import {mapActions, mapState} from 'vuex'
import FormatadorMoeda from '@/commons/components/FormatadorMoeda'
import {actionTypes, tiposLicitacao, tiposNegociacao} from '@/commons/constants'
import AzComboEnumLicitacao from "@/commons/components/AzComboEnumLicitacao";
import EdlFileUpload from "@/commons/components/file/EdlFileUpload.vue";
import ImagemCarouselDialog from "@/commons/components/ImagemCarouselDialog.vue";
import PeriodicidadeUtils from "@/commons/utils/PeriodicidadeUtils";
import {normalizarCasasDecimais} from "@/commons/utils/CasasDecimaisUtils";

export default {
        name: 'LotesItens',
        inject: ['$validator'],
        props: {
            possuiProposta: {
              default: false
            },
            editando: {
                default: false
            },
            publicado:{
                default: false
            }
        },
        components: {ImagemCarouselDialog, EdlFileUpload, AzComboEnumLicitacao, FormatadorMoeda},
        data() {
            return {
                repository: 'repo1:licitacao',
                mostrarDialogRemoverLotes: false,
                tiposImportacao: ['Planilha'],
                tipoImportacao: 'Planilha',
                modelosExportacao: [],
                modeloExportacao: null,
                tiposIncluirFichaCatalogo: [
                    {value: null, text: 'Selecione'},
                    {value: true, text: 'Sim'},
                    {value: false, text: 'Não'}
                ],
                tiposNegociacao,
                orgaoLogado: null,
                itemSendoCarregado: null,
                extensoesPermitidas: ['image/jpg', 'image/jpeg', 'image/png', 'image/webp', 'image/bmp', 'image/pjpg', 'image/tif', 'image/tiff']
            }
        },
        computed: {
            actionTypes() {
                return actionTypes
            },
            licitacao() {
              return this.$store.state.licitacao
            },
            lotesLicitacao() {
                return this.$store.state.lotesLicitacao
            },
            ehPerfilSiga(){
              return !this.$store.state.parametros.propriedadesLicitacao.ehPerfilComprasBR
            },
            isEditavel(){
              return this.licitacao.status === "AGUARDANDO_ABERTURA" &&
                  (this.licitacao.amparoLegal && !this.licitacao.amparoLegal.pncp) ||
                  !this.licitacao.publicado
            },
            possuiLotes() {
                return this.lotesLicitacao.length > 0
            },
            casasDecimaisQuantidade() {
                return normalizarCasasDecimais(this.licitacao.casasDecimaisQuantidade)
            },
            totalGeral() {
                let totalGeral = 0;
                this.lotesLicitacao.forEach(lote => {
                    totalGeral = totalGeral + lote.valorTotal
                })
                return totalGeral
            },
            totalUnitario() {
                let totalUnitario = 0;
                this.lotesLicitacao.forEach(lote => {
                    totalUnitario = totalUnitario + lote.valorUnitario
                })
                return totalUnitario
            },
            mediaDesconto() {
              const valoresDesconto = (this.lotesLicitacao || [])
                  .map(lote => Number(lote && lote.valorDesconto))
                  .filter(Number.isFinite);
              if (!valoresDesconto.length) {
                return 0;
              }
              const somaDescontos = valoresDesconto.reduce(
                  (totalAcumulado, descontoAtual) => totalAcumulado + descontoAtual
              );
              return somaDescontos / valoresDesconto.length;
            },
            isMenorPreco() {
                return tiposLicitacao[this.licitacao.tipoLicitacao] === tiposLicitacao.MP
            },
            isMaiorDesconto() {
              return tiposLicitacao[this.licitacao.tipoLicitacao] === tiposLicitacao.MD
            },
            isMaiorOferta() {
              return tiposLicitacao[this.licitacao.tipoLicitacao] === tiposLicitacao.MO
            },
            isTecnicaPreco() {
              return tiposLicitacao[this.licitacao.tipoLicitacao] === tiposLicitacao.TP
            },
            isMelhorTecnica() {
                return tiposLicitacao[this.licitacao.tipoLicitacao] === tiposLicitacao.MTC
            },
            ehModalidadeLeilao() {
                return this.licitacao && this.licitacao.modalidade && this.licitacao.modalidade.includes('LEILÃO')
            },
            headersTabelaLotes(){
                let headersTabelaLotes = [
                    {
                        text: this.getNomeLote(),
                        align: 'center',
                        sortable: false,
                        value: 'lote',
                        width: '70px',
                        class: 'primary--text'
                    },
                    {
                        text: 'Item',
                        align: 'center',
                        sortable: false,
                        value: 'item',
                        width: '70px',
                        class: 'primary--text'
                    },
                    ... this.ehPerfilSiga ? [{
                        text: 'Seq.',
                        align: 'center',
                        sortable: false,
                        value: 'numSequencia',
                        width: '20px',
                        class: 'primary--text'
                    }] : [],
                    {
                        text: 'Negociação',
                        align: 'center',
                        sortable: false,
                        value: 'tipoNegociacao',
                        width: '50px',
                        class: 'primary--text'
                    },
                    {
                        text: 'Descrição',
                        value: 'descricao',
                        sortable: false,
                        align: 'left',
                        class: 'primary--text'
                    },
                    ... !this.isMelhorTecnica ? [
                    {
                        text: 'Ficha',
                        value: 'ficha',
                        sortable: false,
                        align: 'left',
                        class: 'primary--text'
                    }
                    ] : [],
                    ... !this.isMelhorTecnica ? [
                    {
                        text: 'Catálogo',
                        value: 'catalogo',
                        sortable: false,
                        align: 'left',
                        class: 'primary--text'
                    }
                    ] : [],
                    {
                        text: 'Unidade',
                        value: 'unidade',
                        sortable: false,
                        align: 'left',
                        width: '100px',
                        class: 'primary--text'
                    },
                    {
                        text: 'Qtde',
                        value: 'quantidade',
                        sortable: false,
                        align: 'right',
                        width: '100px',
                        class: 'primary--text'
                    },
                    ... (this.isMenorPreco || this.isMelhorTecnica || this.isMaiorDesconto) && !this.isFornecedor ? [
                      {
                        text: 'Unitário(R$)',
                        value: 'valorUnitario',
                        sortable: false,
                        align: 'right',
                        width: '100px',
                        class: 'primary--text'
                      }
                    ] : [],
                    ... (this.isMaiorDesconto || this.isMenorPreco) && !this.isFornecedor ? [
                      {
                        text: 'Total(R$)',
                        value: 'valorTotal',
                        sortable: false,
                        align: 'right',
                        width: '100px',
                        class: 'primary--text'
                      }
                    ] : [],
                    ... this.isMaiorDesconto && !this.isFornecedor ? [
                      {
                        text: 'Desconto (%)',
                        value: 'Desconto (%)',
                        sortable: false,
                        align: 'right',
                        width: '100px',
                        class: 'primary--text'
                      }
                    ] : [],
                    ... this.isMaiorOferta && !this.isFornecedor ? [
                      {
                        text: 'Oferta',
                        value: 'Oferta',
                        sortable: false,
                        align: 'right',
                        width: '200px',
                        class: 'primary--text'
                      }
                    ] : [],
                    ... this.possuiItemComPeriodicidade && !this.isFornecedor ? [
                      {
                        text: '',
                        value: 'periodicidade',
                        sortable: false,
                        align: 'center',
                        width: '40px',
                        class: 'primary--text'
                      }
                    ] : []
                ]
                return headersTabelaLotes
            },
            ehUsuarioFornecedor() {
                return this.loki.user.domainType === 'FORNECEDOR'
            },
            ...mapState({
                loki: state => state.loki,
                lotesLicitacao: state => state.lotesLicitacao,
                licitacao: state => state.licitacao,
                possuiItemComPeriodicidade: state => state.possuiItemComPeriodicidade
            })
        },
        watch: {
            'loki.uploadedFiles': {
                async handler(newVal) {
                    if (this.itemSendoCarregado) {
                        return
                    }
                    if (this.tipoImportacao === 'Planilha') {
                        this.$emit('onUploadCompletoPlanilhaLotes', newVal)
                    } else {
                        this.$emit('onUploadCompletoTextoLotes', newVal, this.tipoImportacao)
                    }
                }
            }
        },
        methods: {
            ...mapActions({
              buscarLotesItemBase64: actionTypes. BUSCAR_IMAGENS_ITEM_BASE64,
              buscarLotesItemPorLicitacao: actionTypes.BUSCAR_LOTES_ITEM_POR_LICITACAO,
              inserirImagemItem: actionTypes.INSERIR_IMAGENS_ITEM,
            }),
            itemEhPeriodico(item) {
                return PeriodicidadeUtils.possuiPeriodicidade(item)
            },
            dadosTooltipPeriodicidade(item) {
                const meses = PeriodicidadeUtils.mesesPeriodicidade(item)
                const valorTotal = PeriodicidadeUtils.formatarMoeda(item.valorTotal)
                const valorMedioMensal = PeriodicidadeUtils.valorMedioMensal(item.valorTotal, meses)
                return {
                    meses,
                    valorTotal,
                    valorMedioMensal: PeriodicidadeUtils.formatarMoeda(valorMedioMensal)
                }
            },
            async buscarOrgaoLogado() {
              if(this.$store.state.loki.user.type === 'EXTERNO'){return}
              const uo = await this.$store.dispatch(actionTypes.BUSCAR_ORGAO, {orgaoId:this.$store.state.loki.user.domainId});
              if(!uo) {return}
              const orgaos = this.$store.state.orgaos
              this.orgaoLogado = orgaos.find(orgao => orgao.id === uo.unidadeOrganizacional.id)
            },
            getNomeLote() {
              if(this.licitacao.ehPerfilComprasBR) {
                return 'Lote'
              }
              return 'Tipo'
            },
            chamarEventoRemoverLotes() {
                this.$emit('onConfirmarRemoverLotes')
            },
            async buscarNomesModelosImportacao() {
                return await this.$store.dispatch(actionTypes.BUSCAR_NOMES_MODELOS_IMPORTACAO)
            },
            async buscarNomesModelosExportacao() {
                return await this.$store.dispatch(actionTypes.BUSCAR_NOMES_MODELOS_EXPORTACAO)
            },
            async atualizarLotesItens() {
                try {
                    if(!this.licitacao.usuarioComissao){
                      this.mostrarNotificacaoErro('Usuario não faz parte da comissão.')
                      return
                    }
                    const validado = await this.$validator._base.validateAll()
                    if (!validado) {
                        this.mostrarNotificacaoErro('Existem tipos com campos obrigatórios não preenchidos.')
                        return
                    }
                    this.habilitarLoadingGlobal()
                    this.setMensagemLoading('Atualizando os tipos...')
                    await this.$store.dispatch(actionTypes.ATUALIZAR_LOTES_ITENS, {
                        licitacaoId: this.licitacao.id,
                        lotesItens: this.lotesLicitacao
                    })
                    this.mostrarNotificacaoSucessoDefault()
                    this.desabilitarLoadingGlobal()
                } catch (e) {
                    this.desabilitarLoadingGlobal()
                }
            },
            mudarTipoNegociacaoItensMesmoLote(loteId, tipoNegociacao) {
                this.lotesLicitacao.forEach(itemLote => {
                    if (itemLote.licitacaoLote.lote.id === loteId) {
                        itemLote.licitacaoLote.tipoNegociacao = tipoNegociacao
                    }
                })
            },
            mudarFichaCatalogoItensMesmoLote(loteId, valor, campo) {
                this.lotesLicitacao.forEach(itemLote => {
                    if (itemLote.licitacaoLote.lote.id === loteId) {
                        itemLote.licitacaoLote[campo] = valor
                    }
                })
            },
            decodificarBase64(strBase64) {
                return window.decodeURIComponent(window.atob(strBase64).split('').map(function (c) {
                    return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
                }).join(''))
            },
            decodificarBytesString(str) {
                const stringDecodificadaUtf8 = this.decodificarBase64(str)
                const binaryLen = stringDecodificadaUtf8.length
                const bytes = new Uint8Array(binaryLen)
                for (let i = 0; i < binaryLen; i++) {
                    bytes[i] = stringDecodificadaUtf8.charCodeAt(i)
                }

                return [bytes]
            },
            async exportarIpm(){
              try {
                this.habilitarLoadingGlobal()
                this.setMensagemLoading('Exportando tipos...')
                await this.$store.dispatch(actionTypes.EXPORTAR_RESULTADO_IPM, this.licitacao.id)
                this.mostrarNotificacaoSucessoDefault()
                this.desabilitarLoadingGlobal()
              } catch (err) {
                this.desabilitarLoadingGlobal()
              }
            },
            async exportarSgc(){
              try {
                this.habilitarLoadingGlobal()
                this.setMensagemLoading('Exportando tipos...')
                await this.$store.dispatch(actionTypes.EXPORTAR_LOTES_ITENS_SGC, {
                  licitacaoId: this.licitacao.id,
                  nomeModelo: this.modeloExportacao
                })
                this.mostrarNotificacaoSucessoDefault()
                this.desabilitarLoadingGlobal()
              } catch (err) {
                this.desabilitarLoadingGlobal()
              }
            },
            async exportar() {
                try {
                    const validado = await this.$validator._base.validateAll()
                    if (!validado) {
                        return
                    }
                    this.habilitarLoadingGlobal()
                    this.setMensagemLoading('Exportando tipos...')
                    await this.$store.dispatch(actionTypes.EXPORTAR_LOTES_ITENS, {
                        licitacaoId: this.licitacao.id,
                        nomeModelo: this.modeloExportacao
                    })
                    this.mostrarNotificacaoSucessoDefault()
                    this.desabilitarLoadingGlobal()
                } catch (err) {
                    this.desabilitarLoadingGlobal()
                }
            },
            async atualizarDadosSgc(){
                try {
                    this.habilitarLoadingGlobal()
                    this.setMensagemLoading('Atualizando dados...')
                    await this.$store.dispatch(actionTypes.ATUALIZAR_DADOS_SGC, {
                      licitacaoId: this.licitacao.id,
                    })
                    this.mostrarNotificacaoSucessoDefault()
                    this.desabilitarLoadingGlobal()
                    window.location.reload()
                } catch (err) {
                    this.desabilitarLoadingGlobal()
                }
            },
            executarAcaoImagem(item, indexInicial = 0) {
                if (this.podeEditar() && this.naoContemImagem(item)) {
                    this.abrirUploadImagemItem(item)
                }
                else {
                    this.abrirCarouselImagens(item, indexInicial)
                }
            },
            podeEditar() {
                return !this.isFornecedor && this.editando && this.isEditavel
            },
            naoContemImagem(item) {
                return !item.imagens || item.imagens.length === 0
            },
            abrirUploadImagemItem(item) {
                this.itemSendoCarregado = item
                this.resetUploadedFiles()
                this.$refs.uploadImagemItem.openFileSelector()
            },
            abrirUploadImagemItemPorId(itemId) {
                const item = this.lotesLicitacao.find(loteItem => loteItem.id === itemId)
                if (item) {
                    this.abrirUploadImagemItem(item)
                }
            },
            abrirCarouselImagens(item, indexInicial = 0) {
                const itemId = (item && item.id) || null
                const podeEditar = this.podeEditar(item)

                this.$refs.imagemCarouselDialog.open({
                  itemId,
                  index: indexInicial,
                  podeEditar
                })
            },
            async onUploadImagemItemCompleto() {
                try {
                    const imagens = this.loki.uploadedFiles.map(file => {
                        return {
                            uri: file.uri,
                            titulo: file.name,
                            extensao: file.name.split('.').pop()
                        }
                    })
                    const payload = {
                        itemId: this.itemSendoCarregado.id,
                        imagens
                    }

                    this.habilitarLoadingGlobal()
                    this.setMensagemLoading('Salvando imagens do item...')

                    await this.inserirImagemItem(payload)

                    this.mostrarNotificacaoSucesso('Imagens salvas com sucesso!')
                    this.itemSendoCarregado = null

                    await this.buscarLotesItemPorLicitacao(this.licitacao.id)

                    if (this.$refs.imagemCarouselDialog.dialog) {
                        await this.$refs.imagemCarouselDialog.refresh()
                    }
                } finally {
                    this.desabilitarLoadingGlobal()
                }
            },
            async excluirImagemItem({idImagem, callback}) {
                try {
                    this.habilitarLoadingGlobal()
                    this.setMensagemLoading('Excluindo imagem do item...')

                    await this.$store.dispatch(actionTypes.EXCLUIR_IMAGEM_ITEM, {idImagem})

                    this.mostrarNotificacaoSucesso('Imagem excluída com sucesso!')

                    if (callback) {
                        callback()
                    }

                    await this.buscarLotesItemPorLicitacao(this.licitacao.id)
                } finally {
                    this.desabilitarLoadingGlobal()
                }
            },
        },
        async mounted() {
            const nomesModelosImportacao = await this.buscarNomesModelosImportacao()
            const nomesModelosExportacao = await this.buscarNomesModelosExportacao()
            this.tiposImportacao = this.tiposImportacao.concat(nomesModelosImportacao)
            nomesModelosExportacao.forEach((value)=>{
              let obj = {text: value === "Sistema E L" ? "Sistema E&L" : value, value:value}
              this.modelosExportacao.push(obj)
            })
            await this.buscarOrgaoLogado()
        }
    }
</script>

<style scoped lang="stylus">
    .az-lotes-itens
        .reimport-button
            border 1px solid #bbb
            font-size: 13px
            color: #bbb
            text-transform: none
            padding: 10px 15px 10px 10px;
            border-radius: 2px
            transition 0.2s
            i
                margin-right: 5px
                color: #bbb
                font-size 18px
                transition 0.2s

        a[disabled="disabled"]
          pointer-events: none


        .reimport-button:hover
            border 1px solid #3a6861
            background-color: #3a6861
            font-size: 13px
            text-transform: none
            padding: 10px 15px 10px 10px;
            border-radius: 2px
            color: white
            transition 0.2s
            i
                margin-right: 5px
                color: white
                font-size 18px
                transition 0.2s

        .chip-periodico
            align-items: center
            border: 1px solid #0089e6
            border-radius: 12px
            color: #0072bc
            cursor: default
            display: inline-flex
            font-size: 12px
            line-height: 20px
            margin-top: 8px
            padding: 0 8px
            pointer-events: none

            &__icone
                color: #0072bc
                font-size: 14px
                height: 14px
                margin-right: 5px
                width: 14px

        .tipo-item
            align-items: center
            display: flex
            flex-direction: column
            text-align: center

        .resume-itens
            display: block
            margin-bottom: 20px
            margin-top: 10px
            text-align: end
            width: 100%

            .resume
                .separator
                    margin: 0 15px

                label
                    font-weight: bold
                    font-size: 13px
                    color: #777777

                span
                    font-weight: normal
                    font-size: 13px
                    color: #777777

        .link-download-modelo
            background-color: #f0f0f0
            color: #000000
            margin-right: -14px
            &:hover
                background-color: #f0f0f0
                color: #000000
                border: none !important

    .container-tabela-itens
        margin-top: 15px
        overflow auto

    .tabela-lotes-itens
        padding 0px

    .select-itens-tabela
        padding 0px 5px !important

    .az-nowrap-cell
        white-space: nowrap

    .az-nowrap-cell__content
        display: inline-flex
        align-items: center
        gap: 6px

    .az-inline-layout
        display: inline-flex
        flex: 0 0 auto

    .az-cursor-pointer
      cursor: pointer

    @media (max-width: 720px)
        .resume
            display: block
            .separator
                display: block
                visibility: hidden
                height: 0

        .tabela-lotes-itens
            td:nth-of-type(1):before
                content: "Lote:"

            td:nth-of-type(2):before
                content: "Item:"

            td:nth-of-type(3):before
                content: "Negociação:"

            td:nth-of-type(4):before
                content: "Descrição:"

            td:nth-of-type(5):before
                content: "Ficha:"

            td:nth-of-type(6):before
                content: "Catálogo:"

            td:nth-of-type(7):before
                content: "Unidade:"

            td:nth-of-type(8):before
                content: "Quantidade:"

            td:nth-of-type(9):before
                content: "Unitário(R$):"

            td:nth-of-type(10):before
                content: "Total(R$):"
</style>

<style lang="stylus">
    .tooltip-periodicidade-container
        background-color: #ffffff !important
        border: 1px solid #e0e0e0
        border-radius: 3px
        box-shadow: 0 3px 10px rgba(0, 0, 0, .25)
        color: #1f1f1f !important
        opacity: 1 !important
        padding: 16px 18px !important

        .tooltip-periodicidade
            min-width: 260px
            font-size: 14px
            line-height: 1.45

            &__titulo
                color: #0067b1
                font-size: 15px
                font-weight: 600
                margin-bottom: 10px

            &__linha
                display: flex
                justify-content: space-between
                margin-bottom: 8px
                white-space: nowrap

                span:last-child
                    margin-left: 16px

            &__divisor
                border-top: 1px solid #dddddd
                margin: 16px 0

            &__aviso
                color: #757575
                font-size: 13px
                line-height: 1.55
</style>
